import axios, { AxiosResponse } from "axios";
import { createApiHeaders } from "../../../modules/auth/utils/api-headers";

const API_URL_DISBURSE = process.env.REACT_APP_DISBURSEMENT_API_URL;

const getUsers = async (params: any) => {
  return axios
    .get(`${API_URL_DISBURSE}/user/data`, {
      params: {
        ...params.paging,
        userName: params.userName,
      },
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};

const getUser = async (params: any) => {
  return axios
    .get(`${API_URL_DISBURSE}/user/data/${params.id}`, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};

const deleteUser = async (params: any) => {
  return axios
    .delete(`${API_URL_DISBURSE}/user/data/${params.id}`, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};

const createUser = async (params: any) => {
  const payload = {
    ...params,
  };
  return axios
    .post(`${API_URL_DISBURSE}/user/data`, payload, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};

const editUser = async (params: any) => {
  const payload = {
    ...params,
  };
  return axios
    .put(`${API_URL_DISBURSE}/user/data/${params._id}`, payload, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};
export { getUsers, getUser, createUser, deleteUser, editUser };
